import React from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { useAuth } from '../../contexts/authContext';

const OnboardingStep3 = ({ onComplete, onSkip }) => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  const handleAddDisciple = () => {
    // Navigate to Add Disciple page
    navigate('/add-disciple');
  };

  const handleSkip = async () => {
    // Update onboarding step even if skipping
    if (currentUser?.uid) {
      try {
        await updateDoc(doc(db, 'users', currentUser.uid), {
          onboardingStep: 4,
        });
      } catch (error) {
        console.error('Error updating onboarding step:', error);
      }
    }
    onSkip();
  };

  // Check if user has disciples
  const hasDisciple = currentUser?.discipleIds && currentUser.discipleIds.length > 0;

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0076BE] to-[#5ABA47]">
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="max-w-2xl w-full bg-white rounded-xl shadow-2xl p-8">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-[#0076BE] mb-2">
              Add Your First Disciple
            </h2>
            <p className="text-gray-600">Step 3 of 4</p>
          </div>

          <p className="text-gray-700 mb-6 text-center">
            A disciple is someone you're mentoring or discipling. You'll be able to:
          </p>

          <ul className="space-y-3 mb-8">
            <li className="flex items-start">
              <span className="text-[#5ABA47] mr-3 text-xl">•</span>
              <span className="text-gray-700">Track your interactions and connections</span>
            </li>
            <li className="flex items-start">
              <span className="text-[#5ABA47] mr-3 text-xl">•</span>
              <span className="text-gray-700">Send messages with Bible verses</span>
            </li>
            <li className="flex items-start">
              <span className="text-[#5ABA47] mr-3 text-xl">•</span>
              <span className="text-gray-700">Get reminders to stay connected</span>
            </li>
            <li className="flex items-start">
              <span className="text-[#5ABA47] mr-3 text-xl">•</span>
              <span className="text-gray-700">Document their faith journey</span>
            </li>
          </ul>

          {/* Action Buttons */}
          <div className="flex gap-4">
            <button
              onClick={handleSkip}
              className="flex-1 px-6 py-3 border border-gray-300 text-gray-700 font-semibold rounded-lg hover:bg-gray-50 transition-colors"
            >
              Skip for Now
            </button>
            <button
              onClick={handleAddDisciple}
              className="flex-1 px-6 py-3 bg-[#5ABA47] text-white font-semibold rounded-lg hover:bg-[#4a9d3a] transition-colors"
            >
              {hasDisciple ? 'Add Another Disciple' : 'Add Your First Disciple'}
            </button>
          </div>

          {hasDisciple && (
            <p className="mt-4 text-center text-sm text-gray-600">
              You already have {currentUser.discipleIds.length} disciple{currentUser.discipleIds.length > 1 ? 's' : ''}. 
              You can add more or continue to the next step.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default OnboardingStep3;
